<template>
    <div ref="el" class="listen" :class="{'listen--bottom': opened}">
        <audio :src="src" ref="audio" style="display:none"></audio>
        <div class="listen__inner" :class="{'listen--fixed': isOnTop}">
            <div v-if="!started" @click="start()" class="listen__start">
                <a class="listen__player__button listen__player__button--start">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.41 235.55">
                        <polygon class="cls-1" points="8 20.7 100.39 122.41 8 216.05 8 20.7"/>
                    </svg>
                </a>
                <span class="listen__text">Слушать <br>аудио-версию</span>
            </div>
            <div v-else class="listen__player">
                <a @click="moveAudio(-30)" class="listen__player__button listen__player__button--back">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="10 0 230.79 234.63">
                        <polygon class="cls-1" points="222.79 20.93 122.05 122.63 222.79 216.27 222.79 20.93"/>
                        <polygon class="cls-1" points="112.23 19.45 11.49 121.15 112.23 214.79 112.23 19.45"/>
                    </svg>
                </a>
                <a @click="playPause()" class="listen__player__button listen__player__button--play-pause">
                    <svg v-if="!isPlaying" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.41 235.55">
                        <polygon class="cls-1" points="8 20.7 100.39 122.41 8 216.05 8 20.7"/>
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 140.25 229.12">
                        <line class="cls-1" x1="124.25" y1="1.05" x2="125.92" y2="229.05"/>
                        <line class="cls-1" x1="17.33" y1="0.06" x2="16" y2="228.06"/>
                    </svg>
                </a>
                <a @click="moveAudio(30)" class="listen__player__button listen__player__button--forward">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 171.41 235.55">
                        <polygon class="cls-1" points="8 22.18 100.39 123.89 8 217.53 8 22.18"/>
                        <polygon class="cls-1" points="109.39 20.7 201.79 122.41 109.39 216.05 109.39 20.7"/>
                    </svg>
                </a>
                <a class="listen__player__button listen__player__button--volume">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 277.89 228.46">
                        <path class="cls-1" d="M1239.32,666.33a14.13,14.13,0,0,0-15.49,2.64l-62,57.67a3.12,3.12,0,0,1-2.15.85h-57.72A14.51,14.51,0,0,0,1087.42,742v68.7a14.51,14.51,0,0,0,14.49,14.5h57.72a3.16,3.16,0,0,1,2.15.84l62,57.68a14.17,14.17,0,0,0,9.7,3.86,14.51,14.51,0,0,0,5.79-1.22,14.16,14.16,0,0,0,8.61-13.15V679.47A14.15,14.15,0,0,0,1239.32,666.33Zm-2.68,206.86a3,3,0,0,1-5.12,2.23l-62-57.67a14.36,14.36,0,0,0-9.84-3.87h-57.72a3.2,3.2,0,0,1-3.2-3.2V742a3.2,3.2,0,0,1,3.2-3.2h57.72a14.4,14.4,0,0,0,9.84-3.86l62-57.68a3,3,0,0,1,5.12,2.23Z" transform="translate(-1084.42 -662.1)"/>
                        <path class="cls-1" d="M1318.47,685.08a5.65,5.65,0,0,0-7.53,8.42,111.08,111.08,0,0,1,0,165.67,5.65,5.65,0,1,0,7.53,8.42,122.37,122.37,0,0,0,0-182.51Z" transform="translate(-1084.42 -662.1)"/>
                        <path class="cls-1" d="M1300,730.88a5.65,5.65,0,1,0-7.53,8.42,49.66,49.66,0,0,1,0,74.06,5.65,5.65,0,1,0,7.53,8.42,61,61,0,0,0,0-90.9Z" transform="translate(-1084.42 -662.1)"/>
                        <path class="cls-1" d="M1277.37,756.4a5.64,5.64,0,1,0-7.52,8.42,15.45,15.45,0,0,1,0,23,5.64,5.64,0,1,0,7.52,8.42,26.74,26.74,0,0,0,0-39.87Z" transform="translate(-1084.42 -662.1)"/>
                    </svg>
                </a>
                <div class="listen__volume" ref="volume" @mousedown="onStartVolumeChange"  v-ga.click="$ga.commands.click.bind(this,'internal', 'click', 'listen__volume')">
                    <div class="listen__volume__inner">
                        <div class="listen__volume__bar" :style="{height: volume * 100 + '%'}"></div>
                        <div class="listen__volume__handle" :style="volumeHandleStyle"></div>
                     </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="stylus">
    @import "~@/assets/styles/sizes.styl";
    .listen
        cursor pointer
        font-size vw(14, $desktop)
        position relative
        &__start
            display flex
            align-items center
        &__volume
            opacity 0
            position absolute
            right vw(22, $desktop)
            bottom vw(40, $desktop)
            margin-bottom vw(8, $desktop)
            height vw(0, $desktop)
            width vw(2, $desktop)
            background #cb993f
            user-select none
            transition all .35s
            +mobile()
                right vw(28, $mobile)
                bottom vw(40, $mobile)
                margin-bottom vw(16, $mobile)
                height vw(0, $mobile)
                width vw(2, $mobile)
            &__inner
                position relative
                width 100%
                height 100%
            &__bar
                width 100%
                position absolute
                bottom 0
                left vw(-2, $desktop)
                padding vw(2, $desktop)
                background #cb993f
                +mobile()
                    left vw(-2, $mobile)
                    padding vw(2, $mobile)
            &__handle
                cursor pointer
                position absolute
                background #fff
                border-radius 50%
                left vw(-5, $desktop)
                width vw(7, $desktop)
                height vw(7, $desktop)
                border vw(3, $desktop) solid #cb993f
                +mobile()
                    left vw(-5, $mobile)
                    width vw(7, $mobile)
                    height vw(7, $mobile)
                    border vw(3, $mobile) solid #cb993f

        &--fixed &__volume
            bottom auto
            top vw(40, $desktop)
            margin-bottom auto
            margin-top vw(8, $desktop)
        &--fixed &__volume__bar
            bottom auto
            top 0
        &__player__button--volume:hover + &__volume, &__volume:hover
            opacity 1
            height vw(48, $desktop)
            +mobile()
                height vw(48, $mobile)
        +mobile()
            font-size vw(16, $mobile)
        &__icon
            width vw(32, $desktop)
            +mobile()
                width auto
                height vw(44, $mobile)
        &__text

            margin-left vw(8, $desktop)
            br
                display none
            +mobile()
                font-size vw(16, $mobile)
                margin-left vw(10, $mobile)
                text-align left
                line-height vw(24, $mobile)
                br
                    display block
        &--bottom &__text br
            display block
        &--bottom
            position absolute
            top 100%
            left vw(20, $desktop)
            z-index 105
            +mobile()
                display none
        &--fixed
            position fixed
            top vw(20, $desktop)
            left vw(20, $desktop)
        &--mobile-only
            display none
            br
                display none
            +mobile()
                display flex
                margin vw(40, $mobile) 0
        &__player
            display flex
            align-items center
            +mobile()
                position relative
            &__button
                display flex
                align-items center
                justify-content center
                width vw(32, $desktop)
                height vw(32, $desktop)
                border vw(2, $desktop) solid #cb993f
                border-radius 50%
                fill none
                stroke #cb993f
                stroke-width vw(16, $desktop)
                margin vw(4, $desktop)
                +mobile()
                    width vw(48, $mobile)
                    height vw(48, $mobile)
                    border vw(3, $mobile) solid #cb993f
                    stroke-width vw(24, $mobile)
                svg
                    width vw(20, $desktop)
                    height vw(20, $desktop)
                    +mobile()
                        width vw(28, $mobile)
                        height vw(28, $mobile)
                &:hover
                    background #cb993f
                    border-color #fff
                    stroke #fff
                    fill #cb993f
                &--volume
                    stroke-width vw(10, $desktop)
                    +mobile()
                        stroke-width vw(10, $mobile)
    .chapter__buttons .listen
        &__player
            &__button
                +mobile()
                    width vw(32, $mobile)
                    height vw(32, $mobile)
                    border vw(2, $mobile) solid #cb993f
                    stroke-width vw(18, $mobile)
                svg
                    +mobile()
                        width vw(20, $mobile)
                        height vw(20, $mobile)
        &__volume
            +mobile()
                bottom vw(24, $mobile)
                right vw(18, $mobile)

</style>
<script>
    export default {
        methods: {
            start() {
                this.started = true;
                this.playPause(false);
                window.audioStarted = true;
                this.$ga.event('internal', 'click', 'listen__start_'+this.chapter)
            },
            playPause(sendGA = true) {
              if (this.audioEl.paused) {
                  this.audioEl.play();
                  this.isPlaying = true;
                  if (sendGA) this.$ga.event('internal', 'click', 'listen__play')
              } else {
                  this.audioEl.pause();
                  this.isPlaying = false;
                  if (sendGA) this.$ga.event('internal', 'click', 'listen__pause')
              }
            },
            onStartVolumeChange(e) {
              const rect = this.$refs.volume.getBoundingClientRect();
              let onVolumeChange = (e) => {
                  let offset = e.clientY - rect.top;
                  let percent = offset / rect.height;
                  if (percent > 1) {
                      percent = 1;
                  }
                  if (percent < 0) {
                      percent = 0;
                  }
                  this.volume = this.isOnTop ? percent : 1 - percent;
                  this.audioEl.volume = this.volume;
              };

              onVolumeChange(e);
              window.addEventListener('mousemove', onVolumeChange);
              window.addEventListener('touchmove', onVolumeChange);
              window.addEventListener('mouseup', () => {
                  window.removeEventListener('mousemove', onVolumeChange);
                  window.removeEventListener('touchmove', onVolumeChange)
              });
            },
            moveAudio(seconds) {
                if(seconds < 0) this.$ga.event('internal', 'click', 'listen__back'); else this.$ga.event('internal', 'click', 'listen__forward')
                this.audioEl.currentTime += seconds;
            },
            onScroll() {
                let rect = this.$refs.el.getBoundingClientRect();
                this.isOnTop = (rect.top <= rect.height);
            },
        },
        computed: {
            src() {
                return `/${this.chapter}.mp3`
            },
            volumeHandleStyle() {
                  if (this.isOnTop) {
                      return {top: this.volume * 100 + '%'};
                  } else {
                      return {bottom: this.volume * 100 + '%'};
                  }
            },
        },
        mounted() {
            let audio = document.getElementById('audio');
            if (!audio) {
                audio = document.createElement('audio');
                audio.id = "audio";
                audio.src = this.src;
                document.body.appendChild(audio);
            } else {
                this.started = window.audioStarted || false;
                this.isPlaying = !audio.paused;
            }
            this.audioEl = audio;
            if (this.opened) {
                document.body.appendChild(this.$refs.el);
                window.addEventListener('scroll', this.onScroll);
            }
        },
        data() {
            return {
                isOnTop: false,
                volume: .75,
                isPlaying: false,
                started: false,
                audioEl: null,
            }
        },

        props: {
            chapter: {
                type: Number,
                required: true
            },
            opened: {
                type: Boolean,
                required: false,
            }
        },
        beforeDestroy() {
            if (this.opened) {
                document.body.removeChild(this.$refs.el);
                window.removeEventListener('scroll', this.onScroll);
            }
            if (this.audioEl && this.audioEl.parentNode) {
                this.audioEl.parentNode.removeChild(this.audioEl);
            }
        },
        watch: {
            opened(isOpened) {
                if (isOpened) {
                    document.body.appendChild(this.$refs.el);
                    window.addEventListener('scroll', this.onScroll);
                }
            }
        }
    }
</script>